/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WebhookPayloadDto = {
  /**
   * Webhook payload data containing event-specific information
   */
  data: Record<string, any>;
  /**
   * Unique identifier for the webhook event
   */
  event_id: string;
  /**
   * Type of webhook event that occurred
   */
  event_name: WebhookPayloadDto.event_name;
  /**
   * Unix timestamp when the event occurred
   */
  event_time: number;
  /**
   * Indicates if this webhook is from the sandbox environment
   */
  sandbox: boolean;
  /**
   * Description of the webhook subscription
   */
  subscription_description: string;
  /**
   * Unique identifier for the webhook subscription
   */
  subscription_id: string;
};
export namespace WebhookPayloadDto {
  /**
   * Type of webhook event that occurred
   */
  export enum event_name {
    SIGNATURE_REQUEST_ACTIVATED = 'signature_request.activated',
    SIGNATURE_REQUEST_APPROVED = 'signature_request.approved',
    SIGNATURE_REQUEST_CANCELED = 'signature_request.canceled',
    SIGNATURE_REQUEST_DECLINED = 'signature_request.declined',
    SIGNATURE_REQUEST_DELETED = 'signature_request.deleted',
    SIGNATURE_REQUEST_DONE = 'signature_request.done',
    SIGNATURE_REQUEST_EXPIRED = 'signature_request.expired',
    SIGNATURE_REQUEST_PERMANENTLY_DELETED = 'signature_request.permanently_deleted',
    SIGNATURE_REQUEST_REACTIVATED = 'signature_request.reactivated',
    SIGNATURE_REQUEST_REMINDER_EXECUTED = 'signature_request.reminder_executed',
    SIGNER_DECLINED = 'signer.declined',
    SIGNER_DONE = 'signer.done',
    SIGNER_ERROR = 'signer.error',
    SIGNER_IDENTIFICATION_BLOCKED = 'signer.identification_blocked',
    SIGNER_IDENTIFICATION_FAILED = 'signer.identification_failed',
    SIGNER_IDENTIFICATION_SUCCEEDED = 'signer.identification_succeeded',
    SIGNER_IDENTITY_SAVED = 'signer.identity_saved',
    SIGNER_LINK_OPENED = 'signer.link_opened',
    SIGNER_NOTIFIED = 'signer.notified',
    SIGNER_SENDER_CONTACTED = 'signer.sender_contacted',
    SIGNER_NOTIFICATION_DELIVERY_FAILED = 'signer.notification_delivery_failed',
    APPROVER_APPROVED = 'approver.approved',
    APPROVER_NOTIFIED = 'approver.notified',
    APPROVER_REJECTED = 'approver.rejected',
    APPROVER_NOTIFICATION_DELIVERY_FAILED = 'approver.notification_delivery_failed',
    CONTACT_CREATED = 'contact.created',
    VERIFICATION_BANK_ACCOUNT_DONE = 'verification.bank_account.done',
    VERIFICATION_IDENTITY_DOCUMENT_DONE = 'verification.identity_document.done',
    VERIFICATION_IDENTITY_VIDEO_DONE = 'verification.identity_video.done',
    VERIFICATION_COMPANY_DONE = 'verification.company.done',
    ELECTRONIC_SEAL_DONE = 'electronic_seal.done',
    ELECTRONIC_SEAL_ERROR = 'electronic_seal.error',
    USER_COMPLETED = 'user.completed',
    WORKFLOW_ACTION_GROUP_STARTED = 'workflow_action_group.started',
    WORKFLOW_ACTION_GROUP_BLOCKED = 'workflow_action_group.blocked',
    WORKFLOW_ACTION_GROUP_DONE = 'workflow_action_group.done',
    WORKFLOW_SESSION_STARTED = 'workflow_session.started',
    WORKFLOW_SESSION_BLOCKED = 'workflow_session.blocked',
    WORKFLOW_SESSION_DONE = 'workflow_session.done',
  }
}
